import React from "react";
import { useState, useEffect } from 'react';
import { uf_addTimeStr } from '../../modules/utils.mjs'

import '../../index.css';

const CallTable = ({
    serial,
    data,
    updateTable,
    mqttReq
}) => {
    const [tableCallState, setTableCallState] = useState([]);

    const [aaconpbState, setAaconpbState] = useState('')
    const [aainricezioneState, setAainricezioneState] = useState('')
    const [volumemicState, setVolumemicState] = useState('')
    const [volumespeakerState, setVolumespeakerState] = useState('')
    const [updateCallTableState, setUpdateCallTableState] = useState('')
    const handleAaconpbChange = (event) => { setAaconpbState(event.target.value) }
    const handleAainricezioneChange = (event) => { setAainricezioneState(event.target.value) }
    const handleVolumemicChange = (event) => { setVolumemicState(event.target.value) }
    const handleVolumespeakerChange = (event) => { setVolumespeakerState(event.target.value) }

    const [includeAABtPb, setIncludeAABtPb] = useState(false);
    const [includeAABtRec, setIncludeAABtRec] = useState(false);
    const [includeMicVolume, setIncludeMicVolume] = useState(false);
    const [includeSpeakerVolume, setIncludeSpeakerVolume] = useState(false);

    useEffect(() => {
        if ((data !== null) && (data !== undefined))
            uf_addTimeStr(data)
        setTableCallState(data)
    }, [data]);

    function prepareupdatecalltable() {
        if (tableCallState?.aa_bt_pb != null) setAaconpbState(tableCallState.aa_bt_pb);
        if (tableCallState?.aa_bt_rec != null) setAainricezioneState(tableCallState.aa_bt_rec);
        if (tableCallState?.mic_volume != null) setVolumemicState(tableCallState.mic_volume);
        if (tableCallState?.speaker_volume != null) setVolumespeakerState(tableCallState.speaker_volume);
    }

    function updatecalltable() {
        const post_body = {
            serial: serial,
            ...(includeAABtPb && { aa_bt_pb: aaconpbState }),
            ...(includeAABtRec && { aa_bt_rec: aainricezioneState }),
            ...(includeMicVolume && { mic_volume: volumemicState }),
            ...(includeSpeakerVolume && { speaker_volume: volumespeakerState }),
        };
        updateTable(post_body, '/callmqttset', setUpdateCallTableState)
    }

    function refreshcalltable() {
        mqttReq(serial, '/callmqttreq')
    }

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`GatewayDBTable-Section ${isOpen ? 'open' : ''}`}>
            <button onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: '10px' }}>
                {isOpen ? 'Nascondi Call' : 'Mostra Call'}
            </button>
            {isOpen && (
                <table className="GatewayDBTable">
                    <colgroup>
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "5%" }} />
                    </colgroup>
                    <tbody>
                        {/* Title row */}
                        <tr>
                            <th className="tabletitle" colSpan="4">CALL</th>
                        </tr>

                        {/* Header row */}
                        <tr>
                            <th className="title">Campo</th>
                            <th className="title">Valore attuale</th>
                            <th className="title">Nuovo valore</th>
                            <th className="title">✔</th>
                        </tr>

                        {/* AA con PB */}
                        <tr>
                            <td>AA con PB</td>
                            <td style={{ textAlign: 'center' }}>{tableCallState?.aa_bt_pb}</td>
                            <td>
                                <input type="text" value={aaconpbState} onChange={handleAaconpbChange} />
                            </td>
                            <td>
                                <input type="checkbox" checked={includeAABtPb} onChange={() => setIncludeAABtPb(!includeAABtPb)} />
                            </td>
                        </tr>

                        {/* AA in ricezione */}
                        <tr>
                            <td>AA in ricezione</td>
                            <td style={{ textAlign: 'center' }}>{tableCallState?.aa_bt_rec}</td>
                            <td>
                                <input type="text" value={aainricezioneState} onChange={handleAainricezioneChange} />
                            </td>
                            <td>
                                <input type="checkbox" checked={includeAABtRec} onChange={() => setIncludeAABtRec(!includeAABtRec)} />
                            </td>
                        </tr>

                        {/* Volume MIC */}
                        <tr>
                            <td>Volume MIC</td>
                            <td style={{ textAlign: 'center' }}>{tableCallState?.mic_volume}</td>
                            <td>
                                <input type="text" value={volumemicState} onChange={handleVolumemicChange} />
                            </td>
                            <td>
                                <input type="checkbox" checked={includeMicVolume} onChange={() => setIncludeMicVolume(!includeMicVolume)} />
                            </td>
                        </tr>

                        {/* Volume SPEAKER */}
                        <tr>
                            <td>Volume SPEAKER</td>
                            <td style={{ textAlign: 'center' }}>{tableCallState?.speaker_volume}</td>
                            <td>
                                <input type="text" value={volumespeakerState} onChange={handleVolumespeakerChange} />
                            </td>
                            <td>
                                <input type="checkbox" checked={includeSpeakerVolume} onChange={() => setIncludeSpeakerVolume(!includeSpeakerVolume)} />
                            </td>
                        </tr>

                        {/* Ultimo aggiornamento */}
                        <tr>
                            <td className="timetitle">Ultimo aggiornamento</td>
                            <td style={{ textAlign: 'center' }}>{tableCallState?.time}</td>
                            <td style={{ textAlign: 'center' }}>{updateCallTableState}</td>
                        </tr>

                        {/* Buttons row */}
                        <tr>
                            <td colSpan="3" style={{ textAlign: 'center' }}>
                                <button onClick={refreshcalltable} style={{ marginRight: '20px' }}>aggiorna</button>
                                <button onClick={prepareupdatecalltable} style={{ marginRight: '20px' }}>&gt;</button>
                                <button onClick={updatecalltable}>invia</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default CallTable;
